import { connect } from 'react-redux'
import { compose } from 'ramda'
import { getAsyncInfo } from 'selectors/application'
import { isArray } from 'utils/types'
import withStyle from './ErrorBoundary.style.js'
import ErrorBoundary from './ErrorBoundary'

const findErrorObject = (errorDictionary, signalsArray) => {
  const key = Object.keys(errorDictionary).find((key) =>
    signalsArray.includes(key)
  )
  return key ? errorDictionary[key] : null
}

const mapStateToProps = (state, ownProps) => {
  const { waitingSignals, errors } = getAsyncInfo(state)
  const { signal, loading = false, error = false } = ownProps

  if (isArray(signal)) {
    return {
      isWaiting: signal.some((sig) => waitingSignals.has(sig)),
      error: findErrorObject(errors, signal),
    }
  }
  return {
    isWaiting: loading || (signal && waitingSignals.has(signal)),
    error: error || (signal && errors[signal]),
  }
}

export default compose(withStyle, connect(mapStateToProps))(ErrorBoundary)
